/* src/app/components/home/home.component.css */
.content-container {
  height: calc(100% - 80px);
  overflow: auto;
}
/*# sourceMappingURL=home.component.css.map */
